<template>
  <div class="loading" v-if="show"><img src="../assets/loading.gif"/></div>
</template>

<script>
export default {
  name: 'Loading',
  props: ['show']
}
</script>



// WEBPACK FOOTER //
// src/components/Loading.vue